'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isTomorrow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isTomorrow.js
// module id = 560
// module chunks = 0